<template>
  <div class="ei-works-detail">
    <div style="margin-top: 75px"></div>
    <ei-long-figure-scroll-for-write v-if="person.coverArea==='书法家'"
                                     :attaches="typeof works.changJuanAttaches ==='undefined' ? []:works.changJuanAttaches"
                                     :text="works.description"
                                     :works="works"
                                     :headText="headText"
    >
    </ei-long-figure-scroll-for-write>
    <ei-long-figure-scroll-for-paint v-else
                                     :attaches="typeof works.changJuanAttaches ==='undefined' ? []:works.changJuanAttaches"
                                     :text="works.description"
                                     :works="works"
                                     :headText="headText"
    >
    </ei-long-figure-scroll-for-paint>
    <div class="works-title-category">
      <div class="flex-grow1">
      </div>
      <div class="flex-grow3">
        <img :src="worksCommonAttachBg2" class="flex-grow3-bg2"/>
        <div v-if="works.taBenAttaches" style="position: absolute;margin-top: -70px;margin-left: -250px">
          <img
              :src="works.taBenAttaches[works.taBenAttaches.length-1]?works.taBenAttaches[works.taBenAttaches.length-1].url:''"
              class="taBenAttachesSt">
        </div>
        <div class="works-title" v-if="works.worksName">
          <div class="worksTitleDiv">
            <span>{{ works.worksName }}</span>
          </div>
        </div>
        <div class="workWidthDiv">
            <span
                style="position: absolute;margin-top: -91px;margin-left: -305px;width: 500px;font-size: 17px"
                class="workWidthDivZp">
              本卷单行本: 0.5米 X {{ Math.ceil(workWdith / 960) }}米
              <span v-if="this.minute!==0">约{{ this.minute + '分' + this.second + '秒' }}</span>
              <span v-else>约{{ this.second + '秒' }}</span>
                  </span>
          <span style="position: absolute;margin-top: -91px;margin-left: 20px;width: 500px;font-size: 17px;text-align: center"
                class="workWidthDivZp">凌烟阁大法帖·大画谱版权所有©</span>
          <span style="position: absolute;margin-top: -91px;margin-left: 635px;width: 500px;font-size: 17px;text-align: center"
                class="workWidthDivZp">凌烟阁作品未经书面授权禁止使用</span>
          <span style="position: absolute;margin-top: 280px;margin-left: -300px;width: 500px;font-size: 19px"
                class="workWidthDivZp">双勾字帖·书画鉴藏·定制孤本·联系凌烟阁</span>
          <span style="margin-left: -35px" class="workWidthDivHS">
                  竖版册页 约   <div class="numberColor"
                                style="width: 50px;text-align: center;margin-left:-40px;padding-top: 125px;font-family: Fanty;writing-mode: horizontal-tb;">{{
              Math.ceil(workWdith / 480)
            }}</div>
                </span>
          <span style="margin-left: -32px" class="workWidthDivYe">页</span>

          <span style="margin-left: -290px" class="workWidthDivHS">
                  横版册页 约  <div class="numberColor"
                               style="width: 50px;text-align: center;margin-left:-40px;padding-top: 125px;font-family: Fanty;writing-mode: horizontal-tb;">{{
              Math.ceil(workWdith / 1440)
            }}</div>
                </span>
          <span style="margin-left: -286.5px" class="workWidthDivYe">页</span>
        </div>
        <el-carousel :interval="4000" type="card" height="400px" indicator-position="none"
                     style="width: 1050px;margin-left: 100px;margin-top: -95px;">
          <el-carousel-item style="width: 410px;height: 400px;position: absolute"
                            v-for="(item,index) of works.relevantWorksList"
                            :key="index">
            <div><img :src="item.url" alt="版本" style="width: 248px;height: 380px;margin-left: 90px;margin-top: -5px"
                      @click="toWorkDetail(item.rowGuid)"/></div>
            <div class="works-category-title"
                 style="margin-top: -10px;margin-left: 20px;text-align: center;font-size: 26px;width: 400px">
              {{ item.worksName }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="position: absolute;height: 350px; margin-left: 1400px;margin-top: -55px;">
        <span class="portfolioGradient">凌烟阁《清鉴集》关联作品</span>
      </div>
    </div>
    <div class="works-cover-disc">
      <EiStarLight style="position: absolute;transform: scale(0.9,0.9)">
      </EiStarLight>
    </div>
    <ei-music style="margin-top: -790px;margin-left: 158px;position: fixed" :isFlag="isFlag"></ei-music>
    <!--      v-if="works.videoUrl"-->
    <div class="player-container"  v-if="videoFrequency[0]">
      <ei-b-player :videoFrequency="videoFrequency"  :allVideoFrequency="allVideoFrequency" ref="videoRef"></ei-b-player>
    </div>
    <div class="work-content" style="position: relative;height: 520px" v-if="person.coverArea==='书法家'">
      <img :src="worksCommonAttachBg5" style="position: absolute;width: 100%;height: 100%">
      <el-carousel indicator-position="none" :interval="4000" height="550px"
                   style="overflow: hidden;text-align:center;">
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'blackText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'blackText':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'redText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'redText':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'yellowText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'yellowText':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'caiText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'caiText':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="work-content" style="position: relative;height: 520px" v-else>
      <img :src="worksCommonAttachBg5" style="position: absolute;width: 100%;height: 100%">
      <el-carousel indicator-position="none" :interval="6000" height="550px"
                   style="overflow: hidden;text-align:center;">
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'item'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img v-lazy="item.url"/>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'blackText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'blackText':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'whiteText'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <div>
            <img :class="{'whiteText':item.moreStyle==='1'}" v-lazy="item.url"/>
          </div>
        </el-carousel-item>
        <el-carousel-item v-for="(item,index) in works.changJuanAttachesHback" :key="'blackTextGradualChange'+index">
          <div class="contentImg" style="position:absolute" v-if="item.leftTip !== null && item.leftTip.length>28">
            <div class="contenImgLeftTextStyle" v-if="item.leftTip.length<70">
              <span class="textStyle">{{ item.leftTip }}</span>
            </div>
            <div class="contenImgLeftTextStyle" v-else>
              <span class="textStyle" style="transform: scale(0.7,1);">{{ item.leftTip }}</span>
            </div>
          </div>
          <img :class="{'blackTextGradualChange':item.moreStyle==='1'}" v-lazy="item.url"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div style="position:absolute;margin-left: 8px" v-if="descriptionText">
      <div style="width:380px;margin-left: 232px;height:430px;">
        <img style="width: 100%;height:100%" v-lazy="textBg">
      </div>
      <div class="textContent">
        <div class="textMask" style="margin-top: -15px">
        </div>
        <div class="textMask" style="margin-top: 405px">
        </div>
        <span
            style="font-size: 24px;white-space: pre-wrap">{{
            descriptionText.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "。")
          }}</span>
      </div>
    </div>
    <div v-if="works.taBenAttaches" style=";margin-left: 255px;position: absolute;">
      <div>
        <img v-if="works.taBenAttaches[works.taBenAttaches.length-1].imgWidth>=338"
             class="taBenAttachesSt2Big"
             v-lazy="works.taBenAttaches[works.taBenAttaches.length-1] ?works.taBenAttaches[works.taBenAttaches.length-1].url :'' "
        >
        <img
            v-lazy="works.taBenAttaches[works.taBenAttaches.length-1] ?works.taBenAttaches[works.taBenAttaches.length-1].url :'' "
            class="taBenAttachesSt2" v-else>
      </div>
    </div>
    <ei-works-page :works-page="worksPage" @pageNumChange="pageNumChange" style="margin-top: 480px"></ei-works-page>
  </div>
</template>

<script>
import {queryWorksPageAction} from '@/api/reception/works-api'
import {isFailure} from '@/eiuov-utils/axios/response'
import {getUrl} from '@/eiuov-utils/img-util'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
import VueAudio from 'vue-audio-better'
import _ from "lodash";

Vue.use(VueAudio)

export default {
  inject: ['reload'],
  name: 'EiWorksDetail',
  props: {
    works: {
      type: Object,
      required: true,
    },
    person: {
      type: Object,
      required: true
    },
    videoFrequency:{
      type: Array,
      required: true
    },
    allVideoFrequency:{
      type:Array,
      required:true
    },
    headText: {
      type: String,
      required: true,
    },
    descriptionText: {
      type: String,
      required: true,
    },
    musicAttach: {
      type: Object,
      required: true,
    },
    workWdith: {
      type: Number,
      required: true,
    },
    isUsedList: {
      type: Array,
      required: true,
    },
    noUsedList: {
      type: Array,
      required: true,
    },
  },
  watch: {
    works: function (newV) {
      this.$set(this, 'currentCategory', newV.shuangGouAttaches)
      this.$set(this, 'worksCommonAttachBg1', getUrl(newV.worksCommonAttachBg1))
      this.$set(this, 'worksCommonAttachBg2', getUrl(newV.worksCommonAttachBg2))
      this.$set(this, 'worksCommonAttachBg3', getUrl(newV.worksCommonAttachBg3))
      this.$set(this, 'worksCommonAttachBg4', getUrl(newV.worksCommonAttachBg4))
      this.$set(this, 'worksCommonAttachBg5', getUrl(newV.worksCommonAttachBg5))
      this.$set(this, 'textListBgImg', getUrl(newV.textListBgImg))
      this.$set(this, 'textListBgImgMask', getUrl(newV.textListBgImgMask))
      this.$set(this, 'textBg', getUrl(newV.textBg))
      this.jindutiaoTime()

      queryWorksPageAction({
        personName: this.works.author,
        pageNum: this.worksPage.pageNum,
        pageSize: this.worksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.worksPage.list = res.data.list
        this.worksPage.total = res.data.total
      })
    },
  },
  data() {
    return {
      /* musicPused: false,*/
      isFlag:true,
      calligrapherGuid: '',
      categoryActive: 0,
      versionActive: 0,
      currentCategory: [],
      worksCommonAttachBg1: [],
      worksCommonAttachBg2: [],
      worksCommonAttachBg3: [],
      worksCommonAttachBg4: [],
      worksCommonAttachBg5: [],
      textListBgImgMask: [],
      textListBgImg: [],
      textBg: [],
      duration: 0,
      duration_text: 0,
      speed: 150,
      jindutiaoDuration: 0,
      minute: '',
      second: '',
      worksPage: {
        list: [],
        total: 0,
        pageSize: 8,
        pageNum: 1,
      },
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    jindutiaoTime() {
      let totalWidth = 0
      for (let i = 0; i < this.works.changJuanAttaches.length; i++) {
        totalWidth += this.works.changJuanAttaches[i].imgWidth
      }
      if (this.person.coverArea === '书法家') {
        totalWidth = 8 * totalWidth
        let startX = -totalWidth
        let endX = 1920
        var listTime = (endX - startX) / this.speed
        this.jindutiaoDuration = listTime / 8
        if (this.jindutiaoDuration > 60) {
          this.minute = Math.floor(this.jindutiaoDuration / 60)
          this.second = (((this.jindutiaoDuration / 60) - this.minute).toFixed(2))
          this.second = Math.round(this.second * 100)
          if (this.second > 60) {
            this.second = this.second - 60
            if (this.second < 10) {
              this.second = '0' + this.second
            }
            this.minute = this.minute + 1
          } else if (this.second < 10) {
            this.second = '0' + this.second
          }
          if (this.minute < 10) {
            this.minute = '0' + this.minute

          }
        } else {
          this.minute = ''
          this.second = this.jindutiaoDuration + ''
        }
      } else if (this.person.coverArea === '画家') {
        totalWidth = 9 * totalWidth
        let startX = -totalWidth
        let endX = 1920
        var listTime = (endX - startX) / this.speed
        this.jindutiaoDuration = listTime / 9
        if (this.jindutiaoDuration > 60) {
          this.minute = Math.floor(this.jindutiaoDuration / 60)
          this.second = (((this.jindutiaoDuration / 60) - this.minute).toFixed(2))
          this.second = Math.round(this.second * 100)
          if (this.second > 60) {
            this.second = this.second - 60
            this.minute = this.minute + 1
          } else if (this.second < 10) {
            this.second = '0' + this.second
          }
          if (this.minute < 10) {
            this.minute = '0' + this.minute
          }
        } else {
          this.minute = ''
          this.second = this.jindutiaoDuration

        }
      }
    },

    onHandleCategoryClick(index, name) {
      this.categoryActive = index
      if (name === '双勾') {
        this.$set(this, 'currentCategory', this.works.shuangGouAttaches)
      }
      if (name === '拓本') {
        this.$set(this, 'currentCategory', this.works.taBenAttaches)
      }
      if (name === '墨本') {
        this.$set(this, 'currentCategory', this.works.moBenAttaches)
      }
      if (name === '彩本') {
        this.$set(this, 'currentCategory', this.works.caiBenAttaches)
      }
    },
    onHandleVersionClick(index) {
      this.versionActive = index
    },
    pageNumChange(pageNumNew) {
      this.worksPage.pageNum = pageNumNew
      queryWorksPageAction({
        personName: this.works.author,
        pageNum: this.worksPage.pageNum,
        pageSize: this.worksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.worksPage.list = res.data.list
        this.worksPage.total = res.data.total
        this.worksPage.wordCountTotal = res.data.wordCountTotal
      })
    },
    toWorkDetail(rowGuid) {
      this.$cookies.set('works_guid', rowGuid)
      this.$router.push({
        path: '/WorksDetail',
        query: {guid: rowGuid},
      })
    },
  },
}

</script>

<style>
::-webkit-scrollbar{
  width: 0;
}
</style>
<style scoped lang="scss">
@import "./css/ei-common";

* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

.taBenAttachesSt {
  margin-top: 4px;
  height: 310px;
  width: 200px;
  cursor: pointer;
  user-select: none;
  /* animation-name: taBenAttachesStyle;
   animation-duration: 15s;
   animation-iteration-count: infinite;*/
}

.taBenAttachesSt2 {
  margin-top: 2px;
  margin-left: 12px;
  position: absolute;
  height: 425px;
  width: 290px;
  cursor: pointer;
  user-select: none;
  animation-name: taBenAttachesStyle2;
  animation-duration: 15s;
  animation-iteration-count: infinite;
}

@keyframes taBenAttachesStyle2 {
  from {

  }
  to {
    filter: hue-rotate(360deg);
  }
}

.taBenAttachesSt2Big {
  position: absolute;
  padding-left: 55px;
  margin-top: 5px;
  height: 410px;
  width: 440px;
  cursor: pointer;
  user-select: none;
  animation-name: taBenAttachesStyle2big;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  margin-left: -82px;
  display: block;
  transform: scale(0.75, 1);
}

@keyframes taBenAttachesStyle2big {
  from {

  }
  to {
    filter: hue-rotate(360deg);
  }
}

.player-container {
  width: 1440px;
  height: 809px;
  margin: 110px auto 50px;
  overflow: hidden
}

.box {
  width: 1903px;
  height: 50px;
  margin: 0 auto;
  overflow-y: hidden;
  position: relative;
}

.textImgList {
  position: absolute;
  display: flex;
}

.textImgList.img {
  height: 100%;
  float: right;
  margin-left: 0.1px;
}

@keyframes rolling {
  from {
    transform: translateX(-50%);
  }

  to {
    transform: translateX(0%);
  }
}

.textImgList:hover {
  animation-play-state: paused;
}

.textContent {
  width: 1060px;
  height: 430px;
  margin-top: -430px;
  margin-left: 612px;
  padding-left: 20px;
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  overflow-x: auto;
  font-family: SimHei;
  background-color: #ffce7b;
  border: #94070a 1px solid;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(20, 20, 20, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.textMask {
  position: absolute;
  width: 1045px;
  height: 8px;
  margin-left: -20px;
  background-color: #ffce7b;
}

.contentImg {
  width: 100%;
  margin-left: -281px;
  height: 100%;
  vertical-align: middle;
  display: table;
  text-align: center;

  img {
    display: table-cell;
    margin: 0 auto;
  }
}

.ei-works-detail {
  width: 100%;
  overflow: hidden;

  .scroll-img {
    position: relative;
    width: 100%;
    height: 480px;
  }

  .works-title-category, {
    @extend .flex;
    @extend .w1440;
    height: 330px;
    @extend .mlr-auto;
    margin-top: 80px;
  }

  .works-cover-disc {
    @extend .flex;
    @extend .w1440;
    height: 380px;
    @extend .mlr-auto;
    margin-top: 5px;
  }

  .works-desc {
    @extend .flex;
    @extend .justify-content--center;
    @extend .align-items--center;
    @extend .wh100p;

    > div {
      @extend .w100p;
      height: 50px;
      text-align: center;
      color: #fff;
      font-size: 30px;
    }
  }


  .worksTitleDiv {
    position: absolute;
    margin-top: -110px;

    span {
      padding-left: 80px;
      font-size: 24px;
      text-align: center;
      width: 40px;
      height: 390px;
      position: absolute;
      background: linear-gradient(135deg, #14ffe9, #ffeb3b, #ff00e0);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: worksTitleContent 10s linear infinite;
      writing-mode: tb-rl;
    }

    span:hover {
      background: red;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    @keyframes worksTitleContent {
      0% {
        filter: hue-rotate(360deg) brightness(80%)
      }
      50% {
        filter: hue-rotate(360deg) brightness(0%);
      }
      100% {
        filter: hue-rotate(360deg) brightness(80%)
      }
    }

  }

  .works-category-list {
    @extend .flex;
    @extend .justify-content--evenly;
    @extend .align-items--center;
    @extend .h100p;
    color: #fff;

    .works-category {
      @extend .cursor--pointer;

      &.active .works-category-img {
        border: goldenrod solid 2px;
      }

      &.active .works-category-title {
        color: goldenrod;
      }

      .works-category-img {
        width: 140px;
        height: 210px;
        margin-top: -130px;
        position: absolute;
        margin-left: -75px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .works-cover-version {
    @extend .flex;
    @extend .h100p;
    @extend .justify-content--around;
    @extend .align-items--center;

    .works-cover-list {
      @extend .flex;
      @extend .justify-content--around;
      width: 700px;

      .works-cover-item {
        width: 180px;
        height: 270px;
        background-color: #7C1A21;

        img {
          width: 180px;
          height: 270px;
        }
      }
    }

    .works-version-list {
      width: 180px;
      @extend .flex;
      @extend .flex-direction--column;
      @extend .justify-content--evenly;
      @extend .h100p;

      .works-version-item {
        @extend .cursor--pointer;
        height: 40px;
        border: #fff3cd 1px solid;
        text-align: center;
        line-height: 40px;
        color: #fff;

        &.active {
          border: goldenrod 1px solid;
          color: goldenrod;
        }
      }
    }
  }

  .work-content {
    @extend .w1440;
    @extend .mt-30;
    @extend .mlr-auto;
    overflow: hidden;
    min-height: 500px;
    border: #7C1A21 1px solid;
    margin-top: 80px;


    .contenImgTextStyle {
      width: 750px;
      font-size: 25px;
      margin-top: 476px;
      /*  animation-name: contentImgText;
        animation-duration:4s;
        animation-iteration-count: infinite;
        border-radius:25px;*/
      .textStyle {
        text-align: center;
        color: white;
        position: relative;
        white-space: nowrap;
        -webkit-filter: drop-shadow(3px 1px white);
        filter: drop-shadow(3px 1px black);
      }
    }

    .contenImgLeftTextStyle {
      width: 2000px;
      font-size: 25px;
      margin-top: 476px;


      /*  animation-name: contentImgText;
        animation-duration:4s;
        animation-iteration-count: infinite;
        border-radius:25px;*/
      .textStyle {
        text-align: center;
        display: inline-block;
        transform: scale(0.8, 1);
        color: white;
        white-space: nowrap;
        font-family: SimHei;
        -webkit-filter: drop-shadow(3px 1px white);
        filter: drop-shadow(3px 1px black);
      }
    }

  }
}

.blackTextGradualChange {
  position: relative;
  animation-name: blackTextChange;
  animation-duration: 6s;
  animation-iteration-count: infinite;
}

@keyframes blackTextChange {
  0% {
    filter: grayscale(100%) brightness(1%);
  }
  50% {
    filter: grayscale(0%);
  }
  100% {
    filter: grayscale(100%) brightness(1%);
  }
}

.blackText {
  position: relative;
  filter: grayscale(100%) brightness(50%);
}

.whiteText {
  position: relative;
  filter: grayscale(100%) brightness(30%) invert(100%);
  background-color: white;
}

@keyframes bgcolor {
  from {
    filter: hue-rotate(0deg)
  }
  to {
    filter: hue-rotate(360deg)
  }
}

.caiText {
  animation-name: bgcolor;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

.works-category-title:hover {
  animation-name: categoryTitle;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}

@keyframes categoryTitle {
  from {
    color: white;
  }
  to {
    color: #94070a;
  }
}

.portfolioGradient {
  position: absolute;
  background: linear-gradient(135deg, #14ffe9, #ffeb3b, #ff00e0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: portfolioGradientText 10s linear infinite;
  writing-mode: tb-rl;
  font-size: 25px;
  letter-spacing: 2px;

}


@keyframes portfolioGradientHover {
  to {
  }

}

@keyframes portfolioGradientText {
  0% {
    filter: hue-rotate(360deg) brightness(80%)
  }
  50% {
    filter: hue-rotate(360deg) brightness(0%);
  }
  100% {
    filter: hue-rotate(360deg) brightness(80%)
  }

}

.starLightImgD {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
}


.flex-grow3-bg2 {
  width: 1440px;
  height: 330px;
  position: absolute;
  margin-left: -360px;
  animation: flexGrow3Bg2 4s linear infinite;
}

@keyframes flexGrow3Bg2 {
  from {
    filter: hue-rotate(0deg);
  }
  to {
    filter: hue-rotate(360deg);
  }
}

.workWidthDiv {
  position: absolute;
  font-size: 22px;
  letter-spacing: 1px;
  font-family: Fanty
}

.workWidthDivHS {
  position: absolute;
  margin-top: -10px;
  writing-mode: vertical-lr;
  height: 200px;
  animation: workWidthDivHstext 10s linear infinite;
}

@keyframes workWidthDivHstext {
  0% {
    color: black;
  }
  50% {
    color: #94070a;
  }
  100% {
    color: black;
  }
}

.workWidthDivYe {
  margin-top: 145px;
  position: absolute;
  animation: workWidthDivYe 10s linear infinite;
}

@keyframes workWidthDivYe {
  0% {
    color: black;
  }
  50% {
    color: #94070a;
  }
  100% {
    color: black;
  }
}

.workWidthDivMi {
  margin-top: 244px;
  position: absolute;
  animation: workWidthDivMi 10s linear infinite;
}

@keyframes workWidthDivMi {
  0% {
    color: black;
  }
  50% {
    color: #94070a;
  }
  100% {
    color: black;
  }
}

.workWidthDivZp {
  animation: workWidthDivZp 10s linear infinite;
}

@keyframes workWidthDivZp {
  0% {
    color: black;
  }
  50% {
    color: #94070a;
  }
  100% {
    color: black;
  }
}

.numberColor {
  background: linear-gradient(40deg, #FF00FF, #00FFFF, #0000FF, #00FF00, #FFFF00, #FF7D00, #FF0000);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: numberColor 10s linear infinite;
}

@keyframes numberColor {
  to {
    filter: hue-rotate(360deg);
  }
}

.numberColor:hover {
  background: red;
  -webkit-background-clip: text;
}

.worksbg4st {
  background: linear-gradient(40deg, #FF00FF, #00FFFF, #0000FF, #00FF00, #FFFF00, #FF7D00, #FF0000);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: -1440px;
  width: 1440px;
  height: 385px;
  position: absolute;
  animation: worksbg4st 2s linear infinite;

}

@keyframes worksbg4st {
  to {
    filter: hue-rotate(360deg);
  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;

}

</style>
